/**
 * Handle operation in action sheet insert mode plant
 */
export enum ActionInsertPlant {
  UPLOAD_EXISTING_PLANT = 1,
  CREATE_NEW_PLANT = 2,
  START_SCAN = 3,
  DIRECT_SYNCHRONIZATION_FROM_THE_SERVER = 4,
}

/**
 * Handle operation in action sheet to delete/update building
 */
export enum ActionListBuilding {
  UPDATE = 1,
  DELETE = 2,
  MANAGE_USER = 3,
  MANAGE_ENVIRONMENTS = 4,
  SELECT = 5,
}

/**
 * Handle operation in action sheet to delete/update environments
 */
export enum ActionEnvironments {
  UPDATE = 1,
  DELETE = 2,
  ASSOCIATE_USER = 3,
  MANAGE_DEVICES = 4,
  ADD_ROOM = 5,
  CLOSE = 6,
  ACCESS_MANAGEMENT = 7,
  ADD_PART = 8,
  IMPORT_READINGS = 9,
}

/**
 * Handle operation in action sheet to upload a file
 */
export enum ActionUploadFile {
  FROM_CAMERA = 1,
  FROM_FILE_CHOOSER = 2,
}

/**
 * Handle operations on card in action sheet
 */
export enum ActionOnCard {
  DELETE_CARD = 1,
  ACTIVATE_UNLOCK_CARD = 2,
  LOCK_CARD = 3,
  NOTIFY_CUSTOMER = 4,
  WRITE_CARD = 5,
  SHOW_CARD_SETTINGS = 6,
  CLONE_CARD = 7,
  NOTIFY_CARD = 8,
  SET_UID = 9,
}

/**
 * Handle operations on card in action sheet
 */
export enum ActionOnInvitation {
  DELETE = 1,
  SEND_INVITATION = 2,
}

/**
 * Handle operations on card in action sheet
 */
export enum ActionInsertCustomer {
  CREATE_NEW_CUSTOMER = 1,
  CREATE_NEW_STAFF = 2,
  CREATE_NEW_GROUP = 3,
}

/**
 * Handle operations on card in action sheet
 */
export enum ActionInsertBillQuote {
  CREATE_NEW_BILL = 1,
  CREATE_NEW_QUOTE = 2,
}

/**
 * Handle operations on gateway type action sheet
 */
export enum ActionGatewayType {
  GATEWAYTYPE_NONE = 0,
  CONNECT_BOX = 1,
  LOGIC_MACHINE = 2,
  ALFA_SINAPSI = 3,
  EQUOBOX_SINAPSI = 4,
}
/**
 * Handle operations in the action sheet list gateway confiuration
 */
export enum ActionListGateway {
  VIEW_AND_MODIFY = 1,
  LOAD_CONFIGURATION_FILE = 2,
}

/**
 * Handles the operations on the action sheet list environment device management
 */
export enum ActionDeviceType {
  SINAPSI_ALFA = 1,
  SINAPSI_RTUEVO = 2,
  ASSOCIATE_EXISTING_DEVICE = 3,
  SMARTGATEWAY = 4,
  CONNECT_BOX = 5,
  GATEWAY_IOT = 6,
  KNX = 7,
}

/**
 * Handles the operations on the unique Sinapsi devices actionsheet
 */
export enum ActionSinapsiDevice {
  DELETE = 1,
  MODIFY = 2,
  VIEW_CONFIGURATION = 3,
  LOAD_EXCEL = 4,
  START_DISCOVERY = 5
}
